import React, { lazy } from 'react';
import FloatingNavigationMenu from 'components/Navigation/FloatingNavigationMenu';
import CardReveal from 'components/Card/CardReveal';
import ExperienceCards from 'components/Home/ExperienceCards';
import CardSection from 'components/Home/CardSection';
import CardGiftSection from 'components/Home/CardGiftSection';

import debug from 'debug';
import DynamicCollectionListItem from 'components/Collection/DynamicCollectionListItem';
import { shopifyCDNFile } from 'lib/shopifyImageSizer';
import useTransparentMenu from 'effects/useTransparentMenu';
import useStickyMenu from 'effects/useStickyMenu';
import usePhatHeader from 'effects/usePhatHeader';

import Box from '@mui/material/Box';
import DynamicPage from 'components/Layout/DynamicPage';
const d = debug('Homepage');

const VideoMessageSection = lazy(() => import('components/Corporate/VideoMessageSection' /* webpackChunkName: "videoMessageSection" */));

const HomeScreen = () => {
  useStickyMenu(false); // Make content fall behind mene...
  useTransparentMenu(true); // Make menu transparent for first 60 pixels...
  usePhatHeader(true); // Use the phat header (100px vs 60px)

  d('rendering', 'HomeScreen');
  return (
    <>
      <FloatingNavigationMenu />
      <DynamicPage handle="home" />
      <div id="ct" />
      <DynamicCollectionListItem collectionHandle={'best-sellers'} title={'Cards people love'} background={'#00D458'} />
      <DynamicCollectionListItem collectionHandle={'our-top-picks'} title={'Our top picks'} background={'#00E09D'} />
      <CardGiftSection title="Give the ultimate gift of choice." />
      <DynamicCollectionListItem collectionHandle={'big-brands-on-show'} title={'Big brands on show'} background={'#20FFC9'} />
      <DynamicCollectionListItem collectionHandle={'serve-up-a-great-gift'} title={'Serve up a great gift'} background={'#20F2FF'} />
      <VideoMessageSection
        title="Make it personal and send a message from the heart."
        description="Send a personal message with your customised gift card."
        buttonTitle={'Shop Now'}
        buttonLink={'/corporate'}
      />
      <DynamicCollectionListItem collectionHandle={'one-for-the-tech-heads'} title={'Ones for the tech-heads'} background={'#20BCFF'} />
      <DynamicCollectionListItem collectionHandle={'home-is-where-the-heart-is'} title={'Home is where the heart is'} background={'#2094FF'} />
      <Box>
        <CardReveal
          isCompact
          message="Happy Birthday, Ben!"
          description="A completely new way of gifting to those you love."
          cardImageURL={shopifyCDNFile('home-cardReveal.jpg')}
          buttonText="Show Now"
        />
      </Box>
      <DynamicCollectionListItem collectionHandle={'shop-til-you-drop'} title={'Shop till you drop'} background={'#B953FF'} />
      <DynamicCollectionListItem collectionHandle={'keeping-it-active'} title={'Keeping it active'} background={'#FF54EE'} />
      <CardSection
        title="A card for anything they want."
        subtitle="Customisable Prepaid eftpos - spend anywhere, anytime"
        sectionImage={shopifyCDNFile('home-eftposBackground.jpg')}
        cardImage={shopifyCDNFile('home-eftposCard.jpg')}
        buttonText="Discover eftpos"
        redirectPath="/product/eftpos"
      />
      <DynamicCollectionListItem collectionHandle={'let-me-entertain-you'} title={'Let me entertain you'} background={'#FF4897'} />
      <DynamicCollectionListItem collectionHandle={'fun-and-games'} title={'All fun and games'} background={'#FF6B00'} />
      <ExperienceCards collection="multi-choice-cards" title="Give them a range of choice." subtitle="Treat them to fashion, brands gaming or tech, all on one convenient card." />
      <CardSection
        title="Do it the old fashioned way."
        subtitle="Customised physical cards, delivered straight to their place."
        sectionImage={shopifyCDNFile('home-personalisationBackground.jpg')}
        buttonText="Shop Now"
        redirectPath="/corporate"
      />
    </>
  );
};

export default HomeScreen;
